import * as Yup from "yup";
const validationSchema = Yup.object({
    username: Yup.string().when("rememberMe", {
        is: true,
        then: (schema) => schema.notRequired(),
        otherwise: (schema) => schema.required("نام کاربری اجباری می باشد"),
    }),
    password: Yup.string().when("rememberMe", {
        is: true,
        then: (schema) => schema.notRequired(),
        otherwise: (schema) => schema.required("پسورد اجباری می باشد"),
    }),
    rememberMe: Yup.boolean(),
})

let initialLoginBody = {
    username: '',
    password: ''
}

let formContainerStyle = {
    width: { xs: '100%', sm: '50%', md: '50%' },
    minHeight: { xs: '30vh', sm: '100vh' },
    display: 'flex',
    justifyContent: 'start',
    alignItems: 'center',
    p: { xs: 3, sm: 4 },
}

let chaptaContainer={
    width: { xs: '100%'},
    minHeight: { xs: '30vh', sm: '100vh' },
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    p: { xs: 3, sm: 6 },
    // bgcolor:'red'
}

let brandingContainerStyel = {
    width: { xs: '100%', sm: '50%', md: '40%' },
    minHeight: { xs: '30vh', sm: '100vh' },
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    rowGap: { xs: 1.5, sm: 2 },
    backgroundSize: '200% 200%', // اندازه بزرگ‌تر برای جابجایی بهتر
    p: { xs: 2, sm: 6 },
    textAlign: 'center',
    overflow: 'hidden',
    position: 'relative',

}

let primeryButtunStyle = {
    color: 'white',
    padding: '0.6rem 3rem',
    width: '100%',
    borderRadius: 4,
    textAlign: 'center',
    fontSize: { xs: '0.9rem', sm: '1rem' },
}

let formMainTitleStyle = {
    textAlign: 'center',
    boxShadow: 3,
    borderRadius: 4,
    p: 1,
    // pb:2,
    fontSize: { xs: '0.85rem', sm: '0.9rem' },
    mb: { xs: 3, sm: 5 },
}




const containerVariants = {
    animate: {
        backgroundPosition: ['0% 50%', '100% 50%', '0% 50%'], // حرکت گرادیان بین موقعیت‌های مختلف
        transition: {
            duration: 15, // مدت زمان یک چرخه کامل گرادیان
            repeat: Infinity, // تکرار بی‌نهایت
            ease: "linear", // حرکت یکنواخت
        },
    },
};

// انیمیشن ورود المان‌ها (لوگو، متن‌ها)
const fadeInVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.7, ease: "easeOut" } },
};

const fadeInVariants2 = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { duration: 1.2, ease: "easeOut" } },
};
 const fadeInVariants3 = {
  hidden: {
    opacity: 0,
    y: 30,
    scale: 0.7,
  },
  visible: {
    opacity: 1,
    y: [30, -8, 0],
    scale: [0.7, 1.05, 1],
    transition: {
      duration: 0.9,
      ease: "easeOut",
    },
  },
};


const logoPulseVariants = {
    initial: { scale: 1 },
    pulsing: {
        scale: [1, 1.05, 1], // مقیاس از 1 به 1.05 و برگشت به 1
        transition: {
            duration: 3, // هر 3 ثانیه یک‌بار تکرار بشه
            repeat: Infinity,
            ease: "easeInOut",
        },
    },
};

const textVariants = {
    hidden: {
        opacity: 0,
        y: 50,
        scale: 0.8,
        textShadow: '0px 5px 15px rgba(0,0,0,0.1)',
    },
    visible: {
        opacity: 1,
        y: 0,
        scale: 1,
        textShadow: [ // انیمیشن سایه موجی حفظ شده
            '0px 5px 15px rgba(0,0,0,0.3)',
            '0px 10px 25px rgba(0,0,0,0.4)',
            '0px 8px 20px rgba(0,0,0,0.35)',
            '0px 5px 15px rgba(0,0,0,0.3)',
        ],
        transition: {
            duration: 2.5, // زمان کلی انیمیشن موجی
            repeat: Infinity,
            ease: "easeInOut",
            times: [0, 0.3, 0.7, 1], // نقاط کلیدی در طول انیمیشن سایه
            type: "tween", // برای سایه از tween استفاده می‌کنیم

            // --- تنظیمات جدید برای انیمیشن حرکت عمودی (y) ---
            y: {
                duration: 3, // کمی طولانی‌تر از انیمیشن سایه تا هماهنگ بشه
                ease: "easeInOut", // حس موجی و نرم
                type: "keyframes", // استفاده از keyframes برای کنترل دقیق موقعیت موج
                values: [0, 8, -5, 10, -3, 5, 0], // موقعیت‌های مختلف y برای ایجاد موج
                times: [0, 0.15, 0.3, 0.45, 0.6, 0.8, 1], // نقاط کلیدی برای موج y
                repeat: Infinity, // تکرار نامحدود
            },
            // انیمیشن scale هم می‌تونه اضافه بشه
            scale: {
                duration: 3,
                ease: "easeInOut",
                type: "keyframes",
                values: [1, 1.03, 0.98, 1.01, 0.99, 1.02, 1], // تغییرات کوچک مقیاس
                times: [0, 0.15, 0.3, 0.45, 0.6, 0.8, 1],
                repeat: Infinity,
            }
        },
    },
};

export {
    containerVariants,
    fadeInVariants,
    logoPulseVariants,
    textVariants,
    fadeInVariants2,
    validationSchema,
    initialLoginBody,
    formContainerStyle,
    brandingContainerStyel,
    primeryButtunStyle,
    formMainTitleStyle,
    chaptaContainer,
    fadeInVariants3
    
}